module.exports = __webpack_public_path__ + "static/media/01.-Cover-Back.03832ed5.jpg";